<template>
  <router-view />
</template>

<script setup>
</script>

<style>
* { 
  margin: 0; 
  padding: 0; 
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
}

html, body, #app {
  width: 100%;
  min-height: 100vh;
}
</style>
